import { render } from "./TermsAndConditions.vue?vue&type=template&id=c3173918&scoped=true"
const script = {}

import "./TermsAndConditions.vue?vue&type=style&index=0&id=c3173918&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c3173918"

export default script